export default {"src":"/_next/static/media/uber-icon.defb0241.svg","height":63,"width":63,"blurWidth":0,"blurHeight":0};